import { Checkbox, FormControlLabel, FormGroup, Grid } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface CheckboxGroupProps<T> {
  name: string;
  label?: string;
  options: T[];
  disabled?: boolean;
  onChange?: (selected: T[]) => void;
  columns?: number;
  labelKey: keyof T;
  valueKey: keyof T;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
}

export const FormCheckboxGroup = <T,>({
  name,
  options,
  disabled,
  onChange: onChangeProp,
  columns = 2,
  labelKey,
  valueKey,
  xs = 12,
  sm = 12,
  md = 6,
  lg = 4,
  xl = 3,
}: CheckboxGroupProps<T>) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value = [] } }) => {
        const handleChange = (option: T) => (event: React.ChangeEvent<HTMLInputElement>) => {
          const isChecked = event.target.checked;
          const newValue = isChecked ? [...value, option] : value.filter((v: T) => v[valueKey] !== option[valueKey]);

          onChange(newValue);
          if (onChangeProp) {
            onChangeProp(newValue);
          }
        };

        return (
          <FormGroup>
            <Grid container spacing={1}>
              {options.map((option) => (
                <Grid item lg={lg} xs={xs} md={md} xl={xl} sm={sm} key={String(option[valueKey])}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={value.some((v: T) => v[valueKey] === option[valueKey])}
                        onChange={handleChange(option)}
                        disabled={disabled}
                      />
                    }
                    label={String(option[labelKey])}
                  />
                </Grid>
              ))}
            </Grid>
          </FormGroup>
        );
      }}
    />
  );
};
